import { Loading } from 'element-ui'
import store from '../store'
let loading = Loading

function startLoading () {
  loading = Loading.service({
    lock: true,
    text: '加载中……',
    background: 'rgba(0, 0, 0, 0.7)'
  })
}
function endLoading () {
  loading.close()
}
// 那么 showFullScreenLoading() tryHideFullScreenLoading() 要干的事儿就是将同一时刻的请求合并。
// 声明一个变量 needLoadingRequestCount，每次调用showFullScreenLoading方法 needLoadingRequestCount + 1。
// 调用tryHideFullScreenLoading()方法，needLoadingRequestCount - 1。needLoadingRequestCount为 0 时，结束 loading。

export function showFullScreenLoading () {
  if (store.state.needLoadingRequestCount === 0) {
    startLoading()
  }
  store.commit('setLoadCount', true)
  store.commit('setLastRequestFlag', false)
}

export function tryHideFullScreenLoading () {
  if (store.state.needLoadingRequestCount <= 0) return
  store.commit('setLoadCount', false)
  if (store.state.needLoadingRequestCount === 0) {
    endLoading()
    store.commit('setLastRequestFlag', true)
  }
}

let handleLoading = {showFullScreenLoading, tryHideFullScreenLoading}

export {handleLoading}



// WEBPACK FOOTER //
// ./src/util/handleLoading.js